import routes from "@/routes";
import { lazy } from "react";

const ProfileBeta = lazy(() => import("@/modules/VisitorInsight/ProfileBeta"));

/**
 * Sibling of `profileInsight.routes.tsx`, gated on the same
 * `PROFILE_VISITOR_INSIGHTS` permission — the beta pages introduce no new
 * permission and need no roles migration.
 */
const ProfileInsightBetaRoutes = {
  element: <ProfileBeta />,
  path: routes.VISITOR_INSIGHTS.PROFILE_BETA.INDEX,
};

export default ProfileInsightBetaRoutes;
